import api from "./api";

/**
 * Buscar assinatura digital do responsável
 * para usar em documentos PDF
 */

// export const getNomeDirector = async (funcao) => {
//   const  response  = await api.get(`/admins?status=Activo&funcao=${funcao}`);
//   return response.data?.Admins[0] || '';
// }; 

export const getAssinaturaResponsavel = async (
  funcao = "Director Geral"
) => {

  try {

    const response = await api.get(
      `/admins?status=Activo&funcao=${funcao}`
    );

    const responsavel = response?.data?.Admins?.[0];

    if (!responsavel) {
      return null;
    }

    return {
      id: responsavel?._id,
      nome: responsavel?.dadosPessoais?.nome || "",
      funcao: responsavel?.funcao || "",
      email: responsavel?.email || "",
      assinatura: responsavel?.assinaturaURL || "",
      foto: responsavel?.dadosPessoais?.fotoURL || "",
    };

  } catch (error) {

    console.error(
      "Erro ao buscar assinatura do responsável:",
      error
    );

    return null;
  }
};

